import ArrowRight from "../../../../../svgs/arrow-right.svg?react";
import UserInfoExcerpt from "../../../../common/UserInfoExcerpt";
import {
  UserInfoExcerptWrapper,
  UserInfoWrapper,
  UserNameWrapper,
  ViewMoreWrapper,
} from "../../../../common/UserInfoExcerpt/styledComponents";
import { UserInfoDrawerSources } from "../../../../common/UserInfoExcerpt/UserInfoDrawer";
import { useKontaxUserContext } from "../../../../contexts/KontaxUserContext";
import {
  formatDayMonthYear,
  formatMonthYear,
} from "../../../Mandanten/Common/UserDetails/utils";
import { VatMeta } from "../../styledComponents";
import PastDeclarations from "./PastDeclarations";
import UserDetails from "./UserDetails";

const VatDeclarationDetails = ({
  setUpdatedDetails,
}: {
  setUpdatedDetails: Function;
}) => {
  const { user, notes, pastDeclarations, isLoading } = useKontaxUserContext();

  return (
    <VatMeta>
      <UserInfoExcerpt
        user={user}
        notes={notes}
        source={UserInfoDrawerSources.ACCOUNTING}
        isLoading={isLoading}
        renderExcerptData={(excerptData) => {
          return (
            <UserInfoExcerptWrapper>
              <UserNameWrapper>
                {excerptData.user.legalName || "-"}
              </UserNameWrapper>

              <span>
                {excerptData.vatDetails?.isKleinunternehmer && (
                  <UserInfoWrapper>Kleinunternehmer</UserInfoWrapper>
                )}
                {excerptData.user.businessTypeComment && (
                  <UserInfoWrapper>
                    {excerptData.user.businessTypeComment}
                  </UserInfoWrapper>
                )}
                <UserInfoWrapper>
                  FiBu: {formatMonthYear(excerptData.user.fibuStartDate)}
                </UserInfoWrapper>
                <UserInfoWrapper>
                  Billing:{" "}
                  {formatDayMonthYear(excerptData.user.kontaxBillingStartDate)}
                </UserInfoWrapper>
                <UserInfoWrapper>{excerptData.notesCount}</UserInfoWrapper>
              </span>

              <ViewMoreWrapper>
                <span>View more info</span>
                <ArrowRight />
              </ViewMoreWrapper>
            </UserInfoExcerptWrapper>
          );
        }}
      />
      <UserDetails user={user} />
      {user && pastDeclarations?.length > 0 && (
        <PastDeclarations
          pastDeclarations={pastDeclarations}
          email={user.email}
        />
      )}
    </VatMeta>
  );
};

export default VatDeclarationDetails;
